<template>
    <page-title
        title="図案設定"
        icon="bi-palette"
        :backTo="{ name: 'PageKumiiroHome' }"
    />

    <ul class="nav nav-tabs nav-pills mb-3">
        <li
            class="nav-item"
            v-for="school_class in school_classes"
            :key="school_class"
        >
            <button
                class="nav-link rounded-0 rounded-top px-md-5 ms-1 ms-md-2"
                :class="{'active': school_class_id === school_class.school_class_id}"
                type="button"
                @click="setSchoolClass(school_class.school_class_id)"
            >
                {{ school_class.class_name_display }}
            </button>
        </li>
    </ul>

    <div class="d-flex justify-content-between align-items-center">
        <div class="fs-4"><span class="fs-3">{{ selected_theme_ids.length }}</span> 個の図案を選択中</div>
        <button-exec-edit @click="save"></button-exec-edit>
    </div>

    <section v-for="category of categories" :key="category.category_id">
        <section-title :title="category.category_name" />
        <div class="row">
            <div class="col-md-6 col-sm-12 mb-3" v-for="theme of category.themes" :key="theme.theme_id">
                <label class="theme-card" :class="{'theme-card-active': selected_theme_ids.indexOf(theme.theme_id) >= 0}">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 501 501"
                        width="500"
                        height="500"
                        v-html="theme.svg"
                    ></svg>
                    <input type="checkbox" v-model="selected_theme_ids" :value="theme.theme_id">
                    {{ theme.theme_name }}
                </label>
            </div>
        </div>
    </section>

</template>

<script>
import PageTitle from '@/shared/components/design/PageTitle.vue';
import SchoolClass from '../../../shared/models/entities/school-class';
import Category from '../../../shared/models/entities/kumiiro/category';
import Theme from '../../../shared/models/entities/kumiiro/theme';
import SectionTitle from '@/shared/components/design/SectionTitle.vue';
// import AlertNoRecord from '@/shared/components/design/AlertNoRecord.vue';
// import FormSelect from '@/shared/components/form/FormSelect.vue';
// import InlineLoader from '@/shared/components/tool/InlineLoader';
// import TableNormal from '@/shared/components/design/TableNormal.vue';
// import ButtonWrap from '@/shared/components/design/buttons/ButtonWrap.vue';
// import ButtonExecRemove from '@/shared/components/design/buttons/ButtonExecRemove.vue';
import ButtonExecEdit from '@/shared/components/design/buttons/ButtonExecEdit.vue';
// import ButtonExecView from '@/shared/components/design/buttons/ButtonExecView.vue';
// import AccountUser from '@/shared/models/entities/account-user';
// import License from '@/shared/models/entities/license';
// import School from '@/shared/models/entities/school';
// import SchoolClass from '@/shared/models/entities/school-class';
// import IsPending from '@/shared/models/enums/is-pending';
// import Grade from '@/shared/models/enums/grade';

export default {
    name: 'PageKumiiroSettingTheme',
    components: {
        PageTitle,
        SectionTitle,
        // AlertNoRecord,
        // InlineLoader,
        // FormSelect,
        // TableNormal,
        // ButtonExecRemove,
        ButtonExecEdit,
        // ButtonExecView,
        // ButtonWrap,
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage'
    ],
    data() {
        return {
            //対象年度
            year: parseInt(this.$route.query.year),
            //対象学年
            grade: parseInt(this.$route.query.grade),
            //選択中クラス
            school_class_id: null,
            //クラスの一覧
            school_classes: [],
            //図案 (カテゴリ) マスタの一覧
            categories: [],
            themes: [],
            //当該クラス用に選択した図案の一覧
            selected_themes: [],
        }
    },
    mounted() {
        if (this.$helper.isNud(this.year) || this.$helper.isNud(this.grade)) {
            this.showErrorMessage('URLが間違っています');
            this.$router.push({name: 'PageKumiiroHome'});
            return;
        }

        this.getClasses();
        this.getThemes();
    },
    methods: {
        getClasses() {
            //ライセンス (＝クラス) 情報取得
            this.startScreenLoading();
            this.$http.get(`/school/kumiiro/year/${this.year}/grade/${this.grade}/license`)
            .then(response => {
                for (let row of response.data) {
                    this.school_classes.push(new SchoolClass(row.school_class));
                }

                if (this.school_classes.length === 0) {
                    this.showErrorMessage('この学年は申込みがされていません');
                    this.$router.push({name: 'PageKumiiroHome'});
                    return;
                }

                if (this.$route.query.school_class) {
                    //パラメータでクラスが指定されている場合、整合性チェック
                    let school_class = this.school_classes.find((row) => {
                        return row.school_class_id === parseInt(this.$route.query.school_class)
                    });
                    if (!this.$helper.isNud(school_class)) {
                        //整合性OKなら、指定されたクラスをセット
                        this.school_class_id = school_class.school_class_id;
                    } else {
                        //不整合の場合は、1番目をセット
                        this.school_class_id = this.school_classes[0].school_class_id;
                    }
                } else {
                    //未指定の場合は、1番目をセット
                    this.school_class_id = this.school_classes[0].school_class_id;
                }

                this.getSelectedThemes();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        getThemes() {
            //図案一覧取得
            this.startScreenLoading();
            this.$http.get('/school/kumiiro/theme')
            .then(response => {
                for (let row of response.data) {
                    this.categories.push(new Category(row));
                    for (let theme of row.themes) {
                        this.themes.push(new Theme(theme));
                    }
                }
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        getSelectedThemes() {
            //選択済図案の取得
            this.selected_themes = [];

            this.startScreenLoading();
            this.$http.get(`/school/kumiiro/year/${this.year}/grade/${this.grade}/class/${this.school_class_id}/theme`)
            .then(response => {
                for (let row of response.data) {
                    this.selected_themes.push(new Theme(row));
                }
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        setSchoolClass(school_class_id) {
            this.school_class_id = school_class_id;
            this.getSelectedThemes();
        },
        save() {
            this.startScreenLoading();
            this.$http.put(
                `/school/kumiiro/year/${this.year}/grade/${this.grade}/class/${this.school_class_id}/theme`,
                this.selected_themes
            )
            .then(() => {
                this.showMessage('設定しました');
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
    },
    computed: {
        selected_theme_ids: {
            get() {
                let theme_ids = [];
                for (let theme of this.selected_themes) {
                    theme_ids.push(theme.theme_id);
                }
                return theme_ids;
            },
            set(selected_theme_ids) {
                this.selected_themes = [];
                for (let selected_theme_id of selected_theme_ids) {
                    let found = this.themes.find((theme) => {
                        return theme.theme_id === selected_theme_id;
                    })
                    if (!this.$helper.isNud(found)) {
                        this.selected_themes.push(found);
                    }
                }
            },
        },
    },
}
</script>

<style scoped>
.theme-card {display: block; width: 100%; padding: 10px; border: 2px solid var(--bs-secondary); border-radius: 5px;}
.theme-card-active {border: 2px solid var(--bs-info);}
.theme-card svg {width: 100%; height: auto;}
</style>
